import React from 'react';
import { Sun, Moon, LogOut } from 'lucide-react';

export default function Header({ title, session, onLogout, theme, onToggleTheme }) {
  return (
    <header className="topbar">
      <div>
        {/* <div className="eyebrow">WiiZ PORTAL</div> */}
        <h1>{title}</h1>
      </div>

      <div className="profile">
        <button className="theme-toggle" onClick={onToggleTheme} type="button">
          {theme === 'dark' ? <Sun size={13} /> : <Moon size={13} />}
          {theme === 'dark' ? 'Light' : 'Dark'}
        </button>

        <div className="profile-divider" />

        <div className="profile-info">
          <div className="avatar">
            {(session?.name || 'W').charAt(0).toUpperCase()}
          </div>
          <div>
            <b>{session?.name || 'Wiiz Admin'}</b>
            <small>{session?.role || 'Admin'}</small>
          </div>
        </div>

        <button className="icon-btn logout-btn" onClick={onLogout} type="button" title="Logout" aria-label="Logout">
          <LogOut size={16} />
        </button>
      </div>
    </header>
  );
}